var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login_conter"},[_c('div',{staticClass:"login_box"},[_c('loginForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }